import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { FileText, Loader2 } from "lucide-react";

export default function AttachmentThumb({ file }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(file.is_image);

  useEffect(() => {
    let url;
    let active = true;
    if (file.is_image) {
      fetch(`${API}/files/${file.storage_path}`, { credentials: "include" })
        .then((r) => r.blob())
        .then((b) => {
          if (!active) return;
          url = URL.createObjectURL(b);
          setBlobUrl(url);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [file.storage_path, file.is_image]);

  const open = () => window.open(`${API}/files/${file.storage_path}`, "_blank");

  if (file.is_image) {
    return (
      <button
        onClick={open}
        data-testid="attachment-thumb"
        title={file.original_filename}
        className="relative flex h-20 w-20 items-center justify-center overflow-hidden border border-zinc-200 bg-zinc-50 transition-colors hover:border-[#b32233]"
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin text-zinc-400" />
        ) : (
          <img src={blobUrl} alt={file.original_filename} className="h-full w-full object-cover" />
        )}
      </button>
    );
  }
  return (
    <button
      onClick={open}
      data-testid="attachment-thumb"
      title={file.original_filename}
      className="flex h-20 w-20 flex-col items-center justify-center gap-1 border border-zinc-200 bg-zinc-50 p-1 transition-colors hover:border-[#b32233]"
    >
      <FileText className="h-6 w-6 text-zinc-400" />
      <span className="w-full truncate px-1 text-center text-[10px] text-zinc-500">{file.original_filename}</span>
    </button>
  );
}
